import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "../components/Loading";

interface RouteGuardProps {
  isPrivate?: boolean;
  isAuth?: boolean;
}

const RouteGuard = ({
  isPrivate = false,
  isAuth = false,
}: RouteGuardProps) => {
  const location = useLocation();
  const { user, isAuthenticated, isLoading } = useAuth();

  // console.log('RouteGuard - render', { pathname: location.pathname, search: location.search, hash: location.hash, isPrivate, isAuth, isAuthenticated, isLoading });

  if (isLoading) return <Loading />;

  // Sécurité
  if (user?.security) {
    if (!user.security.is_active || user.security.is_suspended) {
      return <Navigate to="/account-disabled" replace />;
    }
  }

  // =============================
  // ROUTES PRIVÉES
  // =============================
  if (isPrivate && !isAuthenticated) {
    // Inclure le chemin, la query string ET le hash
    const fullUrl = location.pathname + location.search + location.hash;
    const redirect = encodeURIComponent(fullUrl);
    return <Navigate to={`/auth/login?redirect=${redirect}`} replace />;
  }

  // =============================
  // ROUTES D'AUTH (login, register)
  // =============================
  if (isAuth && isAuthenticated) {
    const params = new URLSearchParams(location.search);
    const redirectUrl = params.get('redirect');

    if (redirectUrl) {
      const decoded = decodeURIComponent(redirectUrl);
      // console.log('RouteGuard - redirection vers:', decoded);
      // Utiliser window.location pour conserver le hash
      window.location.href = decoded;
      return null; // La redirection est en cours
    }

    // Redirection par défaut
    const isAdmin = user?.roles?.some(r => r.name === "admin");
    if (isAdmin) {
      return <Navigate to="/admin/dashboard/home" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RouteGuard;